import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { AssessmentMemberAnswer } from '../../../../../models/assessment-member-answer';
import { AssessmentFactorSelection } from '../../../../../models/assessment-factor-selection';
import { RiskFactorRank } from '../../../../../models/risk-factor-rank';

@Component({
  selector: 'lib-risk-factor-question',
  templateUrl: './survey-risk-factor-question.component.html',
  styleUrls: ['./survey-risk-factor-question.component.scss']
})
export class SurveyRiskFactorQuestionComponent implements OnInit {
  @Input() templateMemberAnswer: AssessmentMemberAnswer = new AssessmentMemberAnswer();
  @Input() index = 0;
  @Input() userAssessmentMemberAnswer: AssessmentMemberAnswer;
  @Output() openMemberAnswersModalEvent: EventEmitter<null> = new EventEmitter<null>();
  @Output() openCustomFieldsModalEvent: EventEmitter<null> = new EventEmitter<null>();
  public minimumRank = 1; // always 1 per PO instructions;

  constructor(private dialogService: DialogService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    this.setFactorNumericValue();
  }

  setFactorNumericValue() {
    // init so UI doesn't blow up
    /// just precautionary safety code
    this.userAssessmentMemberAnswer?.factors?.forEach((assessmentFactorSelection: AssessmentFactorSelection) => {
      if (!assessmentFactorSelection?.factor || !assessmentFactorSelection?.factor?.id) {
        assessmentFactorSelection.factor = new RiskFactorRank();
        // default it to the 1st one
        // 1st one is often the case N/A - which is not counted
        if (assessmentFactorSelection.type.ranks[1]) {
          assessmentFactorSelection.factor.id = assessmentFactorSelection.type.ranks[1].id;
          assessmentFactorSelection.factor.numericValue = assessmentFactorSelection.type.ranks[1].numericValue;
        } else {
          assessmentFactorSelection.factor.id = assessmentFactorSelection.type.ranks[0].id;
          assessmentFactorSelection.factor.numericValue = assessmentFactorSelection.type.ranks[0].numericValue;
        }
      }

    });
  }

  openMemberAnswersModal() {
    this.openMemberAnswersModalEvent.emit();
  }

  setFactorTypeId(assessmentFactorSelection: AssessmentFactorSelection): void {
    // find the id of the set rank and set the id for saving
    assessmentFactorSelection.factor.id = assessmentFactorSelection.type.ranks.find((r: RiskFactorRank) => r.numericValue === assessmentFactorSelection.factor.numericValue)?.id || null;
  }

  getMax(assessmentFactorSelection: AssessmentFactorSelection): number {
    // max is the length of ranks (not including anything that is n/a or has numeric value of 0)
    return (assessmentFactorSelection.type.ranks.length) - (assessmentFactorSelection.type.ranks.find((r: RiskFactorRank) => r.numericValue === 0) ? 1 : 0);
  }
}
